import { default as __nuxt_component_0 } from "/opt/build/repo/components/Partials/Common/Subaccount/Trigger/Mobile.vue";
import { default as __nuxt_component_1 } from "/opt/build/repo/components/Common/EmptyList.vue";
import { default as __nuxt_component_2 } from "/opt/build/repo/components/Common/Table/Body.vue";
import { default as __nuxt_component_3 } from "/opt/build/repo/components/Partials/Common/Subaccount/Trigger/Header.vue";
import { default as __nuxt_component_4 } from "/opt/build/repo/components/Partials/Common/Subaccount/Trigger/Row.vue";
import { default as __nuxt_component_5 } from "/opt/build/repo/components/Common/Table/Wrapper.vue";
"use strict";
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "h-full" };
const _hoisted_2 = {
  key: 0,
  class: "table"
};
export default /* @__PURE__ */ _defineComponent({
  __name: "Index",
  setup(__props) {
    const derivativeStore = useDerivativeStore();
    const sortedTriggers = computed(
      () => derivativeStore.subaccountConditionalOrders.sort(
        (t1, t2) => t2.updatedAt - t1.updatedAt
      )
    );
    return (_ctx, _cache) => {
      const _component_PartialsCommonSubaccountTriggerMobile = __nuxt_component_0;
      const _component_CommonEmptyList = __nuxt_component_1;
      const _component_CommonTableBody = __nuxt_component_2;
      const _component_PartialsCommonSubaccountTriggerHeader = __nuxt_component_3;
      const _component_PartialsCommonSubaccountTriggerRow = __nuxt_component_4;
      const _component_CommonTableWrapper = __nuxt_component_5;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CommonTableBody, {
          "show-empty": _unref(sortedTriggers).length === 0,
          class: "sm:hidden max-h-lg"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_CommonEmptyList, {
              message: _ctx.$t("trade.emptyTriggers"),
              class: "pb-4 bg-gray-900"
            }, null, 8, ["message"])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedTriggers), (trigger, index) => {
              return _openBlock(), _createBlock(_component_PartialsCommonSubaccountTriggerMobile, {
                key: `mobile-derivative-triggers-${index}-${trigger.orderHash}`,
                class: "col-span-1",
                trigger
              }, null, 8, ["trigger"]);
            }), 128))
          ]),
          _: 1
        }, 8, ["show-empty"]),
        _createVNode(_component_CommonTableWrapper, { class: "hidden sm:block" }, {
          default: _withCtx(() => [
            _unref(sortedTriggers).length > 0 ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
              _createVNode(_component_PartialsCommonSubaccountTriggerHeader),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedTriggers), (trigger, index) => {
                  return _openBlock(), _createBlock(_component_PartialsCommonSubaccountTriggerRow, {
                    key: `triggers-${index}-${trigger.orderHash}`,
                    trigger
                  }, null, 8, ["trigger"]);
                }), 128))
              ])
            ])) : (_openBlock(), _createBlock(_component_CommonEmptyList, {
              key: 1,
              message: _ctx.$t("trade.emptyTriggers")
            }, null, 8, ["message"]))
          ]),
          _: 1
        })
      ]);
    };
  }
});
